import Fssai from "./Fssai";
import Gst from "./Gst";
import IecCode from "./IecCode";
import Msme from "./Msme";
import Pan from "./Pan";
import Tan from "./Tan";
import Patent from "./Patent";
import Pf from "./Pf";
import Trademark from "./Trademark";
import  StatutoryRegistration  from "./StatutoryRegistration";
import Professional from "./Professional";

export default StatutoryRegistration;
export { Fssai, Gst, IecCode, Msme,Pan,Patent,Pf,StatutoryRegistration,Professional,Tan,Trademark};